import React from 'react'

function GBP({ className, size }) {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={size ?? 32}
      height={size ?? 32}
      fill='none'
      viewBox='0 0 32 32'
    >
      <path
        d='M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z'
        fill='#00B26B'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.087 14.815V12.483C11.087 8.807 13.306 6.5 17.162 6.5C20.094 6.5 21.732 7.742 23 9.34L20.517 11.24C19.566 10.075 18.667 9.39 17.189 9.39C15.419 9.39 14.362 10.607 14.362 12.56V14.815H20.94V17.452H14.362V21.787H22.947V24.5H9V22.523L11.087 21.914V17.452H9V14.815H11.087Z'
        fill='white'
      />
    </svg>
  )
}

export default GBP
